<script setup lang="ts">
import VueTurnstile from 'vue-turnstile';
import { useAppStore } from '@/store/app';
import { useRouter } from 'vue-router';
import { verifyTurnstile } from '@/api/apiMain';
import { captureException } from '@sentry/vue';
import { useMutation } from '@tanstack/vue-query';
import { snackbarPush } from '@/helpers/snackbarPush';

const store = useAppStore();
const router = useRouter();

const {
  mutate: verifyExecute,
  isPending: verifyIsLoading,
  isError,
} = useMutation({
  mutationFn: verifyTurnstile,
  onSuccess: () => {
    try {
      router.push(
        router.currentRoute.value.redirectedFrom || {
          name: 'Home',
        },
      );
    } catch (error) {
      captureException(error);
    }
  },
  onError: (error) => {
    snackbarPush('Error verifying turnstile');
    captureException(error);
  },
});

async function setTurnstileToken(token: string) {
  store.setTurnstileToken(token);
  verifyExecute();
}
</script>

<template>
  <v-container class="py-16 items-center flex flex-col gap-4">
    <div class="text-h6">Proof of humanity required</div>
    <vue-turnstile
      class="mt-2"
      site-key="0x4AAAAAAAR_Qo1Xh3MycusL"
      v-on:update:model-value="setTurnstileToken"
      :model-value="store.turnstileToken || ''"
    />
    <div v-if="verifyIsLoading">Wait for redirection...</div>
    <div v-if="isError">An error occurred</div>
  </v-container>
</template>
